export const EbayUrl: string = "https://www.ebay.co.uk/sch/redfifty/m.html?_nkw=&_armrs=1&_ipg=&_from=";
export const Email: string = "sales@redbridgemotors.co.uk";
export const Phone: string = "07976 843677";
export const ContactUrl: string = "https://redbridge-motors.azure-api.net/redbridge-motors/get-in-touch";